let phoneReg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;//11位手机号
let emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/; //邮箱
let idReg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/;  //18位从1900到2099年中间的范围验证
let idCodReg = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
let nameReg = /^[\u4e00-\u9fa5]{2,6}$/;
let isNumber = (val) => {
    var regPos = /^\d+(\.\d+)?$/
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
    if (regPos.test(val) || regNeg.test(val)) {
        return true
    } else {
        return false
    }
}
let isChinese = (val) => {
    var reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
    if (reg.test(val)) {
        return true
    } else {
        return false
    }
}
let FormValidate = (function () {
    function FormValidate() { }
    // From表单验证规则  可用于公用的校验部分
    FormValidate.Form = function () {
        return {
            // 手机号的验证规则
            validatePhone(rule, value, callback) {
                if (value) {
                    if (!phoneReg.test(value.replace(/\s+/g, ""))) {
                        return callback(new Error('请输入正确的手机号'))
                    } else {
                        callback()
                    }
                } 
                // else if (!value.replace(/\s+/g, "")) {
                //     return callback(new Error('请输入手机号'))
                // }
                else {
                    callback()
                }

            },

            // 邮箱的验证规则
            validateEmail(rule, value, callback) {
                if (value) {
                    if (!emailReg.test(value)) {
                        return callback(new Error('请输入正确的email地址'))
                    } else {
                        callback()
                    }
                } else {
                    callback()
                }
            },

            // 性别验证
            sexy(rule, value, callback) {
                setTimeout(() => {
                    if (!isChinese(value)) {
                        callback(new Error('请输入汉字'));
                    } else if (isChinese(value)) {
                        if(value =='男' || value =='女'){
                            callback();
                        }else{
                            callback(new Error('请输男或女'));
                        }
                    } else {
                        callback();
                    }
                }, 0);
            },
            // 价格校验
            priceProp(rule, value, callback) {
                setTimeout(() => {
                    if (!isNumber(value)) {
                        callback(new Error('请输入数字值'));
                    } else if (isNumber(value) && value <= 0) {
                        callback(new Error('请输入大于零的数值'));
                    } else {
                        callback();
                    }
                }, 0);
            },

            // 手机号的验证规则
            validateIdCode(rule, value, callback) {
                if (value) {
                    if (!idCodReg.test(value)) {
                        return callback(new Error('请输入正确的身份证号'))
                    } else {
                        callback()
                    }
                } 
                // else if (!value.replace(/\s+/g, "")) {
                //     return callback(new Error('请输入手机号'))
                // }
                else {
                    callback()
                }

            },
            // 姓名
            validateName(rule, value, callback) {
                if (value) {
                    if (!nameReg.test(value)) {
                        return callback(new Error('请输入正确的姓名'))
                    } else {
                        callback()
                    }
                } 
                // else if (!value.replace(/\s+/g, "")) {
                //     return callback(new Error('请输入手机号'))
                // }
                else {
                    callback()
                }

            },

        }
    }

    return FormValidate
}())

exports.FormValidate = FormValidate;
